import axios from 'axios'

export const AdminJurisdictionService = {
  fetchJurisdictionList (status) {
    let queryParams = '?'
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}&`
    }
    return axios.get(`/api/v1/jurisdictionlist${queryParams}`)
  },
  // get jurisdiction list
  fetchJurisdictionByStateAndCounty (countryId, stateId, countyId, fetchOnlyPublished) {
    let queryParams = '?'
    if (countryId !== undefined && countryId !== '') {
      queryParams += `cId=${countryId}&`
    }
    if (stateId !== undefined && stateId !== '') {
      queryParams += `sId=${stateId}&`
    }
    if (countyId !== undefined && countyId !== '') {
      queryParams += `cntId=${countyId}&`
    }
    if (fetchOnlyPublished !== undefined && fetchOnlyPublished !== '') {
      queryParams += `status=${fetchOnlyPublished}&`
    }
    return axios.get(`/public/api/v1/jurisdictionlist${queryParams}`)
  },
  fetchPaginatedJurisdictionList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/getjurisdictionlist${queryParams}`)
    } else {
      return axios.get(`/api/v1/getjurisdictionlist`)
    }
  },
  fetchFIPSList () {
    return axios.get(`/api/v1/jurisdictionfips`)
  },
  fetchFilteredJurisdictionList (countryId, stateId, countyId, status) {
    let queryParams = '?'
    if (countryId !== undefined && countryId !== '') {
      queryParams += `cId=${countryId}&`
    }
    if (stateId !== undefined && stateId !== '') {
      queryParams += `sId=${stateId}&`
    }
    if (countyId !== undefined && countyId !== '' && countyId !== null) {
      queryParams += `cntId=${countyId}&`
    }
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}&`
    }
    return axios.get(`/api/v1/jurisdictionlist${queryParams}`)
  },
  addJurisdictionItem (data) {
    return axios.post(`/api/v1/addjurisdiction`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  editJurisdictionItem (data) {
    return axios.post(`/api/v1/editjurisdiction`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  fetchJurisdictionPostalCode (id) {
    if (id !== undefined && id !== null && id !== '') {
      return axios.get(`/api/v1/getjurisdictionpostalcode/${id}`)
    } else {
      return axios.get(`/api/v1/getjurisdictionpostalcode`)
    }
  },
  getJurisdictionDetailsById (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `jId=${id}&`
    }
    return axios.get(`/api/v1/jurisdiction${queryParams}`)
  },
  // get results of text searched
  fetchTextJurisdictionSearch (data) {
    return axios.post(`/api/v1/jurisdictionsearch`, JSON.stringify({
      searchString: data.searchString,
      countyId: data.countyId,
      stateId: data.stateId,
      countryId: data.countryId,
      status: data.status
    }))
  },
  validateDeleteJuridictionItem (Data) {
    return axios.delete(`/api/v1/deletejurisdiction`, {
      data: Data
    })
  },
  deleteJuridictionItem (Data) {
    return axios.delete(`/api/v1/deletejurisdiction`, {
      data: Data
    })
  }
}
